export const offersDE = {
    shippingTitle : "KOSTENLOSER VERSAND",
    shippingText1 : "Für Bestellungen über ",
    shippingText2 : "€ versandkostenfrei!",
    cashTitle : "BAR BEI LIEFERUNG",
    cashText : "Kostenlose Nachnahme!" ,
    topSellers : "Topseller"  
}